import { Injectable } from '@angular/core';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { take, tap } from 'rxjs/operators';
import { Chat } from '../../models/Chat';
import { AppChatMsgGetRequest } from '../SicorService/RequestObject/AppChatMsgGetRequest';
import { AppChatInsRequest } from '../SicorService/RequestObject/AppChatInsRequest';
import * as moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { GlobalVariablesService } from '../global-variables.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(
    private sicorAPI: SicorApiService,
    private gvs: GlobalVariablesService) { }

  public async appGetChat(user: string, s_ins: number, chat_user: number, chat_tp: number, msg_from_start_ind: number): Promise<Chat[]> {
    let chat: Chat[] = [];
    let s_chat = 0;
    if (chat_tp === 0) {
      s_chat = this.gvs.craChatID;
    } else if (chat_tp === 4) {
      s_chat = this.gvs.supportChatID;
    }
    const requestParams: AppChatMsgGetRequest = new AppChatMsgGetRequest(user, s_chat, s_ins, chat_user, chat_tp, msg_from_start_ind);
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.appGetChatRequest(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              for (let i = 0; i < res.resultSet.length; i++) {
                let tempChat: Chat = new Chat();
                tempChat.name = res.resultSet[i].name;
                tempChat.contact_tp = res.resultSet[i].contact_tp;
                tempChat.chat_text = res.resultSet[i].chat_text;
                tempChat.ins_dt = res.resultSet[i].ins_dt;
                tempChat.s_chat = res.resultSet[i].s_chat;
                tempChat.user_ind = res.resultSet[i].user_ind;
                tempChat.own = res.resultSet[i].user_ind === 'X' ? true : false;
                tempChat.time = moment(res.resultSet[i].ins_dt).format('HH:mm');
                tempChat.date = moment(res.resultSet[i].ins_dt).format('DD/MM/YYYY');
                chat.push(tempChat);
              }
              chat.sort(function (a, b) {
                return new Date(a.ins_dt).getTime() - new Date(b.ins_dt).getTime();
              });
              chat.forEach(function callback(currentValue: Chat, index, array) {
                if (msg_from_start_ind === 1) {
                  if (index === 0) {
                    currentValue.showdate = true;
                  } else {
                    const date1 = new Date(array[index].ins_dt).getFullYear() + '-' + new Date(array[index].ins_dt).getMonth() + '-' + new Date(array[index].ins_dt).getDate();
                    const date2 = new Date(array[index - 1].ins_dt).getFullYear() + '-' + new Date(array[index - 1].ins_dt).getMonth() + '-' + new Date(array[index - 1].ins_dt).getDate();
                    if (date1 !== date2) {
                      currentValue.showdate = true;
                    } else {
                      currentValue.showdate = false;
                    }
                  }
                } else {
                  currentValue.showdate = false;
                }
              });
              if (chat.length > 0) {
                if (chat_tp === 0) {
                  this.gvs.craChatID = chat[0].s_chat;
                } else if (chat_tp === 4) {
                  this.gvs.supportChatID = chat[0].s_chat;
                }
              }
              resolve(chat);
            }
          }, error: e => {
            resolve(null);
          }
        })
      ));
    });
  }

  public async cAppChatIns(user: string, s_ins: number, chat_tp: number, text_msg: string, s_chat: number): Promise<boolean> {
    const installation = this.gvs.currentInstallation;
    const requestParams: AppChatInsRequest = new AppChatInsRequest(user, s_chat, s_ins, chat_tp, text_msg, installation.s_pc, installation.s_cont, installation.cix); // TO DO: REVISAR ESE 0 QUE ES EL S_CHAT
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.appInsChatRequest(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet[0].error != null && res.resultSet[0].error === 0) {
              resolve(true);
            } else {
              resolve(false);
            }
          }, error: e => {
            resolve(false);
          }
        })
      ));
    });
  }
}
